import { GESTION_OPERATIVA_SELECT_LINEA_FINANCIERA } from './constants'
import { financing } from '@asofix/core'

export function selectLineaFinanciera(
  selectedLineaFinanciera,
  montoAfinanciar,
  cuotasAfinanciar,
  nombre,
  banco,
  cft,
  tna,
  cuotaMensual,
  listLinesSelected,
  quebrantoPorc,
  expenses,
  valorPrimeraCuota
) {
  return {
    type: GESTION_OPERATIVA_SELECT_LINEA_FINANCIERA,
    data: {
      selectedLineaFinanciera,
      cuotasAfinanciar,
      montoAfinanciar,
      nombre,
      banco,
      cft,
      tna,
      cuotaMensual,
      listLinesSelected,
      quebrantoPorc,
      expenses,
      valorPrimeraCuota
    }
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_SELECT_LINEA_FINANCIERA) {
      const {
        selectedLineaFinanciera,
        cuotasAfinanciar,
        montoAfinanciar,
        nombre,
        banco,
        cft,
        tna,
        cuotaMensual,
        listLinesSelected,
        quebrantoPorc,
        expenses,
        valorPrimeraCuota: cuotaCadaMilPesos
      } = action.data

      let credit_line_dcosts = 0
      if(montoAfinanciar && (quebrantoPorc || expenses)) {
        credit_line_dcosts = (montoAfinanciar * quebrantoPorc) / 100 + expenses
      }
    
      const credit_line_first_quote_value = financing.getInitialFee(montoAfinanciar, cuotaCadaMilPesos)

      if (!selectedLineaFinanciera) {
        return {
          ...state,
          sale: {
              ...state.sale,
            credit_line_id: null,
            credit_line_fees: 0,
            fees_number: 0,
            amount_2b_financed: 0,
            credit_line_name: null,
            credit_line_banco: null,
            credit_line_cft: 0,
            credit_line_tna: 0,
            monthly_avg_fee: 0,
            listLinesSelected: [],
            credit_line_dcosts: 0,
            credit_line_first_quote_value: 0
          }
        }
      }
      return {
        ...state,
        sale: {
            ...state.sale,
            credit_line_id: selectedLineaFinanciera,
            credit_line_fees: cuotasAfinanciar,
            fees_number: cuotasAfinanciar,
            amount_2b_financed: montoAfinanciar,
            credit_line_name: nombre,
            credit_line_banco: banco,
            credit_line_cft: cft,
            credit_line_tna: tna,
            monthly_avg_fee: cuotaMensual,
            listLinesSelected,
            credit_line_dcosts,
            quebrantoPorc,
            expenses,
            credit_line_first_quote_value
        }
      }
  }
  else {
      return state
  }
}
